angular.module('app.financeiro').factory('estornoIntegracaoDbsFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'EstornoIntegracaoDBS';

    var _list = function (search, options, dataInicio, dataTermino, parceiro, tipoContrato, vlrMin, vlrMax, gridInstance) {
        var dto = options.data;

        dto.search = search;

        dto.parms = [];
        dto.parms.push({ "name": "DataInicio",   "value": dataInicio });
        dto.parms.push({ "name": "DataTermino",  "value": dataTermino });
        dto.parms.push({ "name": "Parceiro",     "value": parceiro || null });
        dto.parms.push({ "name": "TipoContrato", "value": tipoContrato || null });
        dto.parms.push({ "name": "VlrMin",       "value": vlrMin || null });
        dto.parms.push({ "name": "VlrMax",       "value": vlrMax || null });

        if (gridInstance) gridInstance.parms = dto.parms;

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _historico = function (search, options, dataInicio, dataTermino, parceiro, tipoContrato, vlrMin, vlrMax, gridInstance) {
        var dto = options.data;

        dto.search = search;

        dto.parms = [];
        dto.parms.push({ "name": "DataInicio",   "value": dataInicio });
        dto.parms.push({ "name": "DataTermino",  "value": dataTermino });
        dto.parms.push({ "name": "Parceiro",     "value": parceiro || null });
        dto.parms.push({ "name": "TipoContrato", "value": tipoContrato || null });
        dto.parms.push({ "name": "VlrMin",       "value": vlrMin || null });
        dto.parms.push({ "name": "VlrMax",       "value": vlrMax || null });

        if (gridInstance) gridInstance.parms = dto.parms;

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Historico', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _aprovarEstorno = function (codigos, motivo) {
        var dto = { parms: [] };
        dto.parms.push({ "name": "CodigosEstornos", "value": codigos.join(',') });
        dto.parms.push({ "name": "motivo",           "value": motivo });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AprovarEstorno', dto);
    };

    var _reprovarEstorno = function (codigos, motivo) {
        var dto = { parms: [] };
        dto.parms.push({ "name": "CodigosEstornos", "value": codigos.join(',') });
        dto.parms.push({ "name": "motivo",           "value": motivo });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReprovarEstorno', dto);
    };

    var _listParceiros = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListParceiros');
    };

    var _listTiposContrato = function (codigoParceiro) {
        var dto = { parms: [] };
        if (codigoParceiro) dto.parms.push({ name: 'CodigoParceiro', value: codigoParceiro });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListTiposContrato', dto);
    };

    var _listEstornosRelacionados = function (codigoTransacaoOrigem, modo, options) {
        var dto = options.data;
        dto.parms = [
            { name: 'CodigoTransacaoOrigem', value: codigoTransacaoOrigem },
            { name: 'Modo', value: modo || 'estorno' }
        ];
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListEstornosRelacionados', dto)
            .then(function (response) {
                options.success(response.data);
            }, function (response) {
                var erro = {};
                erro.data = response.data;
                errorService.processError(erro, options);
            });
    };

    var factory = {};

    factory.list                    = _list;
    factory.historico               = _historico;
    factory.aprovarEstorno          = _aprovarEstorno;
    factory.reprovarEstorno         = _reprovarEstorno;
    factory.listParceiros           = _listParceiros;
    factory.listTiposContrato       = _listTiposContrato;
    factory.listEstornosRelacionados = _listEstornosRelacionados;

    return factory;
}]);
